export const DisallowedElementsArray = [
  "audio",
  "form",
  "iframe",
  "input",
  "noscript",
  "script",
  "style",
  "textarea"
];
